import api from './api.service';
import {
  ContractStatusResponse,
  ContractSummary,
  SignContractPayload,
} from './types/contracts.type';

export const contractsService = {
  getStatus: async (): Promise<ContractStatusResponse> => {
    return api.get('/contracts/me/status').then((res) => res.data);
  },

  listMine: async (): Promise<ContractSummary[]> => {
    return api.get('/contracts/me').then((res) => res.data);
  },

  getById: async (id: string): Promise<ContractSummary> => {
    return api.get(`/contracts/${id}`).then((res) => res.data);
  },

  getDownloadUrl: async (id: string): Promise<string> => {
    return api.get(`/contracts/${id}/download`).then((res) => res.data.url);
  },

  getAddendumDownloadUrl: async (id: string): Promise<string> => {
    return api
      .get(`/contracts/addendums/${id}/download`)
      .then((res) => res.data.url);
  },

  requestEmailCode: async (contractId: string): Promise<{ sent: boolean }> => {
    return api.post(`/contracts/${contractId}/request-email-code`).then((res) => res.data);
  },

  sign: async (contractId: string, payload: SignContractPayload): Promise<any> => {
    return api.post(`/contracts/${contractId}/sign`, payload).then((res) => res.data);
  },

  requestAddendumEmailCode: async (addendumId: string): Promise<{ sent: boolean }> => {
    return api
      .post(`/contracts/addendums/${addendumId}/request-email-code`)
      .then((res) => res.data);
  },

  signAddendum: async (addendumId: string, payload: SignContractPayload): Promise<any> => {
    return api
      .post(`/contracts/addendums/${addendumId}/sign`, payload)
      .then((res) => res.data);
  },
};
